module.exports = __webpack_public_path__ + "img/invitations_2.278b9556.jpg";